module.exports = __webpack_public_path__ + "static/img/info1.09207ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/info1.png
// module id = y6hs
// module chunks = 44